var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-row',{staticClass:"content-title text-center"},[_c('h2',{staticClass:"gray-text"},[_vm._v("Выберите раздел")])])}
var staticRenderFns = []

export { render, staticRenderFns }